import { request, resetCustomOnResponseError, setCustomOnResponseError } from './axios'
import { Import, Export, ImportAd, ExportAd, SyncSummary, SyncHistoryData } from '../type/admin'
import { customErrorResponse } from '../utility/custom-error-response'
import { createDownloadLink } from '../utility/download-link'
import { dateFormat, Format } from '../utility/date-format'

export const Synchronization = {
  export: async (): Promise<Export> => {
    setCustomOnResponseError(customErrorResponse)
    try {
      const { data } = await request({
        url: '/datasync/export/',
        method: 'post',
      })
      return data
    } finally {
      resetCustomOnResponseError()
    }
  },

  import: async (): Promise<Import> => {
    setCustomOnResponseError(customErrorResponse)
    try {
      const { data } = await request({
        url: '/datasync/import/',
        method: 'post',
      })
      return data
    } finally {
      resetCustomOnResponseError()
    }
  },

  exportAd: async (): Promise<ExportAd> => {
    setCustomOnResponseError(customErrorResponse)
    try {
      const { data } = await request({
        url: '/datasync/export/ad/',
        method: 'post',
      })
      return data
    } finally {
      resetCustomOnResponseError()
    }
  },
  importAd: async (): Promise<ImportAd> => {
    setCustomOnResponseError(customErrorResponse)
    try {
      const { data } = await request({
        url: '/datasync/import/ad/',
        method: 'post',
      })
      return data
    } finally {
      resetCustomOnResponseError()
    }
  },

  syncCc: async (): Promise<SyncSummary> => {
    setCustomOnResponseError(customErrorResponse)
    try {
      const { data } = await request({
        url: '/datasync/cc/',
        method: 'post',
      })
      return data
    } finally {
      resetCustomOnResponseError()
    }
  },

  syncNpiEligibility: async (): Promise<SyncSummary> => {
    setCustomOnResponseError(customErrorResponse)
    try {
      const { data } = await request({
        url: '/datasync/npi-eligibility/',
        method: 'post',
      })
      return data
    } finally {
      resetCustomOnResponseError()
    }
  },

  getHistory: async (page = 1): Promise<SyncHistoryData> => {
    setCustomOnResponseError(customErrorResponse)
    try {
      const {
        data: { results, max_page_size, page_number, total_count, total_pages },
      } = await request({
        url: `/datasync/history/?page_number=${page}`,
      })
      return { results, max_page_size, page_number, total_count, total_pages }
    } finally {
      resetCustomOnResponseError()
    }
  },

  exportHistoryToExcel: async (page: number): Promise<void> => {
    setCustomOnResponseError(customErrorResponse)
    try {
      const dateTime = dateFormat(new Date(), Format['YYYY-MM-DD__HH:MM:SS'])
      const { data } = await request({
        responseType: 'arraybuffer',
        url: `/datasync/history/export_to_excel/?page_number=${page}`,
        method: 'post',
      })
      createDownloadLink(data, `synchronizations_history_${dateTime}.xlsx`)
    } finally {
      resetCustomOnResponseError()
    }
  },
}
